import styled from 'styled-components'

export const Styles = styled.div`

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
        background: #ff0000;

      }
    }
  }
}
`

export const PaginationStyles = styled.div`
  margin: 1rem auto; 

  button {
    border: 1px solid black;
    margin-right: 0.5rem;
    padding: 0.25rem 1rem;
  }

  span {
    input {
    border: 1px solid #775f55;
    border-radius: 3px;
    padding: 0.25rem 0.25rem;
    width: 5rem; 

    :focus {
      outline: none;
    }
    }
  }

  select {
    border: 1px solid black;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 0.25rem 1rem;
    border: 1px solid #775f55;
  }
`

export const DownloadStyles = styled.div`

  a {
    margin: 1rem auto; 
    background: #167fe0;
    font: inherit;
    border: 1px solid #167fe0;
    border-radius: 3px;
    padding: 0.25rem 1rem;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.26);
    color: white;
    cursor: pointer;
    text-decoration: none;
}
`

export const UploadStyles = styled.div`

  input[type="file"] {
    display: none;
  }

  label {
    margin: 1rem auto; 
    border: 1px solid black;
    border-radius: 3px;
    display: inline-block;
    padding: 0.25rem 1rem;
    cursor: pointer;

    :hover {
      border: 1px solid #167fe0;
      color: #167fe0;
    }
  }
`
